// extracted by mini-css-extract-plugin
export default {"anomalyCard":"styles_anomalyCard__NhRGs","expandBtn":"styles_expandBtn__iVSc-"};